import { render, staticRenderFns } from "./view.vue?vue&type=template&id=ff0f6688&scoped=true"
import script from "./view.vue?vue&type=script&lang=js"
export * from "./view.vue?vue&type=script&lang=js"
import style0 from "./view.vue?vue&type=style&index=0&id=ff0f6688&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff0f6688",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("G:\\pinmingproject\\suppervision-manager-ui-huangshi\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ff0f6688')) {
      api.createRecord('ff0f6688', component.options)
    } else {
      api.reload('ff0f6688', component.options)
    }
    module.hot.accept("./view.vue?vue&type=template&id=ff0f6688&scoped=true", function () {
      api.rerender('ff0f6688', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/modules/traddingWitness/expertWitness/view.vue"
export default component.exports